export default function WizardStep({ children, stepIndex, currentStep }) {


    return (
        <div style={{ display: (stepIndex === currentStep) ? "inherit" : "none" }}>
            {children}
        </div>
    );
}